import useSelector from '../../../redux/hooks/useSelector';

import {selectCurrentPath} from './selectCurrentPath';


export default function useCurrentPath(): string {
  return useSelector((state) => selectCurrentPath(state));
}
